import { createReducer } from "utils/redux";

export const PROFILE_CHANGE_PASSWORD_SUCCESS = 'PROFILE_CHANGE_PASSWORD_SUCCESS';
export const PROFILE_CHANGE_PASSWORD_FAILED = 'PROFILE_CHANGE_PASSWORD_FAILED';

export const ChangePasswordResult = createReducer(
    PROFILE_CHANGE_PASSWORD_SUCCESS,
    PROFILE_CHANGE_PASSWORD_FAILED,
  );